
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"-2 -1 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 16V1.775m11.667 8.408v-8.35s-.73.606-2.917.606C7.562 2.44 6.104 1 3.917 1 1.729 1 1 1.777 1 1.777m0 8.39s.73-.606 2.917-.606S7.563 11 9.75 11c2.188 0 2.917-.814 2.917-.814","stroke-width":"1.25","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    